// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desempeno-employee .icon {
	background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
	width: 50px;
	height: 50px;
	border-radius: 50rem;
	padding: 8px;
	margin-right: 10px;
	display: flex;
	align-items: center;
}

.desempeno-employee .icon svg {
	fill: white;
	width: 100%;
}

.radio-style {
	background-color: white;
	border: 2px solid #c4c4c4;
	color: #c4c4c4;
	padding: 6px 25px 9px 25px;
	border-radius: 13px;
	font-weight: 600;
}

.radio-style:hover {
	background-color: #6d68aa;
	border: 2px solid #41c8ff;
	color: white;
}

.radio-style label {
	padding-top: 4px;
}

.radio-style.radio-style-active {
	background-color: #6d68aa;
	border: 2px solid #41c8ff;
	color: white;
}

.rowLabel {
	background-color: #c5f0e8;
	border-radius: 13px;
}

.remuneracionTitleTextLittle {
	font-size: 13px;
}

.remuneracionDescripcionTextLittle {
	font-size: 14px;
}

.countPlusMinusInput {
	max-width: 60px;
	border-radius: 13px !important;
	border: 2px solid #9c9c9c !important;
	background-color: white;
	text-align: center;
	margin: 0 !important;
}

.countInputPlusMinusButton {
	background-color: transparent;
	border: none;
	outline: none;
	margin: 10px;
}

.table-desempeno thead tr th:not(:nth-child(1)),
.table-desempeno tbody td:not(:first-child) {
	text-align: center;
}

.inputInicio,
.inputFin,
.inputRemuneracion {
	max-width: 50px;
	text-align: center;
}

.btn-analisis-search {
	padding: 0px 15px 0px 15px;
	border: 2px solid #6d68aa;
	border-radius: 0px 13px 13px 0px !important;
	border-left: none !important;
	margin-left: -5px;
}

.desempeno-employee .loading {
	position: absolute;
	top: 0;
	left: 361px;

	width: calc(100% - 370px);
	height: 100%;
	background: rgba(255, 255, 255, 1);
	z-index: 1;
}

.form-control.input-analisis-search {
	border-right: none !important;
	border-radius: 13px 0px 0px 13px !important;
	margin: 0 !important;
	background: #ffffff;
	height: 36px;
	border: 2px solid #6d68aa;
	box-sizing: border-box;
	font-family: 'Montserrat', sans-serif !important;
	outline: none;
	padding: 0 18px;
}

.add-remove-button {
	background: none;
	color: #4e5857 !important;
	border: none;
}

.analisisInputRow input.inputRow[type='text'] {
	border: none;
	border-bottom: 1px solid #4e5857;
	border-radius: 1px !important;
	padding: 0 10px;
	margin: 0;
	height: 30px;
	background-color: #f8f8f8b8;
}

.analisisInputRow input.peso,
.analisisInputRow input.logrado {
	max-width: 150px;
	margin: auto !important;
	text-align: center;
}

.analisisInputRow .checkRow {
	border-radius: 25px;
	height: 25px;
	width: 25px;
}

.resultBox {
	border: 2px solid #45b9eb;
	background-color: #45b9eb;
	color: white;
	width: fit-content;
	padding: 15px 15px 5px 15px;
	border-radius: 10px;
	margin-bottom: 50px;
}

.list-title {
	cursor: default;
}

.employer-list {
	list-style: none;
	padding: 5px 0px 5px 5px;
	border: 2px solid #4e58577d;
	margin-top: 5px;
	border-radius: 15px;
	transition: height ease 0.5s;
	background-color: white;
	height: 70px;
}

.img-fixed-size {
	width: 50px;
	height: 50px !important;
}

.btn-salvar {
	background-color: #45b9eb !important;
	color: white !important;
}

.btn-salvar:hover {
	background: #5ac2ad;
	color: white;
}

.container-media {
	margin-top: -110px;
}

.clickable-row {
	cursor: pointer;
}

.employer-list.expand-card {
	height: 450px;
	overflow: auto;
}

.hidden {
	visibility: hidden;
	opacity: 0;
}

.borderPurple {
	border: 2px solid #7a6be8;
	border-color: #7a6be8 !important;
	border-radius: 1rem;
	padding: 5px;
}

.CritSuggestions {
	background-color: #40c2ff;
	color: white;
	cursor: pointer;
}
.CritSuggestions:hover {
	background-color: #2b97db;
	color: white;
}
`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/RemuneracionVariable/styles.css"],"names":[],"mappings":"AAAA;CACC,4DAA4D;CAC5D,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;CACzB,cAAc;CACd,0BAA0B;CAC1B,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,8BAA8B;CAC9B,oCAAoC;CACpC,uBAAuB;CACvB,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;CAC7B,YAAY;CACZ,aAAa;CACb,YAAY;AACb;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;;CAGC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB,2CAA2C;CAC3C,4BAA4B;CAC5B,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,WAAW;;CAEX,yBAAyB;CACzB,YAAY;CACZ,kCAAkC;CAClC,UAAU;AACX;;AAEA;CACC,6BAA6B;CAC7B,2CAA2C;CAC3C,oBAAoB;CACpB,mBAAmB;CACnB,YAAY;CACZ,yBAAyB;CACzB,sBAAsB;CACtB,gDAAgD;CAChD,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gCAAgC;CAChC,6BAA6B;CAC7B,eAAe;CACf,SAAS;CACT,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;;CAEC,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,2BAA2B;CAC3B,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,2BAA2B;CAC3B,eAAe;CACf,mBAAmB;CACnB,4BAA4B;CAC5B,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;CAChC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,eAAe;AAChB;AACA;CACC,yBAAyB;CACzB,YAAY;AACb","sourcesContent":[".desempeno-employee .icon {\n\tbackground: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);\n\twidth: 50px;\n\theight: 50px;\n\tborder-radius: 50rem;\n\tpadding: 8px;\n\tmargin-right: 10px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.desempeno-employee .icon svg {\n\tfill: white;\n\twidth: 100%;\n}\n\n.radio-style {\n\tbackground-color: white;\n\tborder: 2px solid #c4c4c4;\n\tcolor: #c4c4c4;\n\tpadding: 6px 25px 9px 25px;\n\tborder-radius: 13px;\n\tfont-weight: 600;\n}\n\n.radio-style:hover {\n\tbackground-color: #6d68aa;\n\tborder: 2px solid #41c8ff;\n\tcolor: white;\n}\n\n.radio-style label {\n\tpadding-top: 4px;\n}\n\n.radio-style.radio-style-active {\n\tbackground-color: #6d68aa;\n\tborder: 2px solid #41c8ff;\n\tcolor: white;\n}\n\n.rowLabel {\n\tbackground-color: #c5f0e8;\n\tborder-radius: 13px;\n}\n\n.remuneracionTitleTextLittle {\n\tfont-size: 13px;\n}\n\n.remuneracionDescripcionTextLittle {\n\tfont-size: 14px;\n}\n\n.countPlusMinusInput {\n\tmax-width: 60px;\n\tborder-radius: 13px !important;\n\tborder: 2px solid #9c9c9c !important;\n\tbackground-color: white;\n\ttext-align: center;\n\tmargin: 0 !important;\n}\n\n.countInputPlusMinusButton {\n\tbackground-color: transparent;\n\tborder: none;\n\toutline: none;\n\tmargin: 10px;\n}\n\n.table-desempeno thead tr th:not(:nth-child(1)),\n.table-desempeno tbody td:not(:first-child) {\n\ttext-align: center;\n}\n\n.inputInicio,\n.inputFin,\n.inputRemuneracion {\n\tmax-width: 50px;\n\ttext-align: center;\n}\n\n.btn-analisis-search {\n\tpadding: 0px 15px 0px 15px;\n\tborder: 2px solid #6d68aa;\n\tborder-radius: 0px 13px 13px 0px !important;\n\tborder-left: none !important;\n\tmargin-left: -5px;\n}\n\n.desempeno-employee .loading {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 361px;\n\n\twidth: calc(100% - 370px);\n\theight: 100%;\n\tbackground: rgba(255, 255, 255, 1);\n\tz-index: 1;\n}\n\n.form-control.input-analisis-search {\n\tborder-right: none !important;\n\tborder-radius: 13px 0px 0px 13px !important;\n\tmargin: 0 !important;\n\tbackground: #ffffff;\n\theight: 36px;\n\tborder: 2px solid #6d68aa;\n\tbox-sizing: border-box;\n\tfont-family: 'Montserrat', sans-serif !important;\n\toutline: none;\n\tpadding: 0 18px;\n}\n\n.add-remove-button {\n\tbackground: none;\n\tcolor: #4e5857 !important;\n\tborder: none;\n}\n\n.analisisInputRow input.inputRow[type='text'] {\n\tborder: none;\n\tborder-bottom: 1px solid #4e5857;\n\tborder-radius: 1px !important;\n\tpadding: 0 10px;\n\tmargin: 0;\n\theight: 30px;\n\tbackground-color: #f8f8f8b8;\n}\n\n.analisisInputRow input.peso,\n.analisisInputRow input.logrado {\n\tmax-width: 150px;\n\tmargin: auto !important;\n\ttext-align: center;\n}\n\n.analisisInputRow .checkRow {\n\tborder-radius: 25px;\n\theight: 25px;\n\twidth: 25px;\n}\n\n.resultBox {\n\tborder: 2px solid #45b9eb;\n\tbackground-color: #45b9eb;\n\tcolor: white;\n\twidth: fit-content;\n\tpadding: 15px 15px 5px 15px;\n\tborder-radius: 10px;\n\tmargin-bottom: 50px;\n}\n\n.list-title {\n\tcursor: default;\n}\n\n.employer-list {\n\tlist-style: none;\n\tpadding: 5px 0px 5px 5px;\n\tborder: 2px solid #4e58577d;\n\tmargin-top: 5px;\n\tborder-radius: 15px;\n\ttransition: height ease 0.5s;\n\tbackground-color: white;\n\theight: 70px;\n}\n\n.img-fixed-size {\n\twidth: 50px;\n\theight: 50px !important;\n}\n\n.btn-salvar {\n\tbackground-color: #45b9eb !important;\n\tcolor: white !important;\n}\n\n.btn-salvar:hover {\n\tbackground: #5ac2ad;\n\tcolor: white;\n}\n\n.container-media {\n\tmargin-top: -110px;\n}\n\n.clickable-row {\n\tcursor: pointer;\n}\n\n.employer-list.expand-card {\n\theight: 450px;\n\toverflow: auto;\n}\n\n.hidden {\n\tvisibility: hidden;\n\topacity: 0;\n}\n\n.borderPurple {\n\tborder: 2px solid #7a6be8;\n\tborder-color: #7a6be8 !important;\n\tborder-radius: 1rem;\n\tpadding: 5px;\n}\n\n.CritSuggestions {\n\tbackground-color: #40c2ff;\n\tcolor: white;\n\tcursor: pointer;\n}\n.CritSuggestions:hover {\n\tbackground-color: #2b97db;\n\tcolor: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
